import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-center m-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Join the Memphis Lions Club"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "1000 Lions are now available")
], -1)

import ModalBase from '@/components/modals/ModalBase.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MintLive',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    title: "Mint is Live!",
    "close-text": "Close",
    "show-other-button": true,
    "other-button-text": "Mint Now!"
  }, {
    content: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})